import type { ChangeEvent } from 'react';
import { Download, Trash2, X } from 'lucide-react';

import type { LeadDisplayStatus } from './leads.schema';
import styles from './leads.module.css';

const STATUS_OPTIONS: { value: LeadDisplayStatus; label: string }[] = [
  { value: 'new', label: 'חדש' },
  { value: 'contacted', label: 'יצרנו קשר' },
  { value: 'qualified', label: 'הוסמך' },
  { value: 'disqualified', label: 'לא רלוונטי' },
  { value: 'converted', label: 'הומר לדיל' },
];

interface LeadBulkBarProps {
  selectedCount: number;
  disabled?: boolean;
  onStatusChange: (status: LeadDisplayStatus, label: string) => void;
  onDelete: () => void;
  onExportCsv: () => void;
  onClear: () => void;
}

export function LeadBulkBar({
  selectedCount,
  disabled = false,
  onStatusChange,
  onDelete,
  onExportCsv,
  onClear,
}: LeadBulkBarProps) {
  function handleStatusChange(event: ChangeEvent<HTMLSelectElement>) {
    const value = event.target.value as LeadDisplayStatus | '';
    if (!value) return;
    const label = STATUS_OPTIONS.find((option) => option.value === value)?.label ?? value;
    onStatusChange(value, label);
    event.target.value = '';
  }

  return (
    <div className={styles.bulkBar}>
      <strong>
        <span className="num">{String(selectedCount)}</span> לידים נבחרו
      </strong>

      <label className={styles.bulkSelect}>
        <span>שנה סטטוס</span>
        <select defaultValue="" disabled={disabled} onChange={handleStatusChange}>
          <option value="" disabled>
            בחר
          </option>
          {STATUS_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      <button
        type="button"
        className={styles.bulkButton}
        disabled={disabled}
        onClick={onExportCsv}
      >
        <Download size={15} aria-hidden="true" />
        ייצא CSV
      </button>

      <button type="button" className={styles.bulkButton} disabled={disabled} onClick={onDelete}>
        <Trash2 size={15} aria-hidden="true" />
        מחק
      </button>

      <button type="button" className={styles.bulkButton} disabled={disabled} onClick={onClear}>
        <X size={15} aria-hidden="true" />
        בטל בחירה
      </button>
    </div>
  );
}
